import type { LanguageValue } from './editor-languages'

export const DEFAULT_SNIPPETS: Record<LanguageValue, string> = {
  javascript: '',
  python: '',
  cpp: '',
  java: '',
  go: '',
}
